import React from 'react'
import AnnouncementCom from '../Component/AnnouncementCom'

const Announcement = () => {
  return (
    <div>
        <AnnouncementCom/>
    </div>
  )
}

export default Announcement